import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { doc, onSnapshot } from "firebase/firestore";
import { store } from "@root/store";
import { projectLastModified } from "@config/firestore";
import { updateProjectLastModifiedLocally } from "./actions";
export var subscribeToProjectLastModified = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(projectUid) {
        var unsubscribe;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1)
                switch (_context2.prev = _context2.next) {
                    case 0:
                        unsubscribe = onSnapshot(doc(projectLastModified, projectUid), /*#__PURE__*/ function () {
                            var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(timestampDocument) {
                                var _timestampDocument$da, timestamp;
                                return _regeneratorRuntime.wrap(function _callee$(_context) {
                                    while (1)
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                if (timestampDocument.exists()) {
                                                    _context.next = 2;
                                                    break;
                                                }
                                                return _context.abrupt("return");
                                            case 2:
                                                _timestampDocument$da = timestampDocument.data(), timestamp = _timestampDocument$da.timestamp;
                                                _context.t0 = timestamp;
                                                if (!_context.t0) {
                                                    _context.next = 7;
                                                    break;
                                                }
                                                _context.next = 7;
                                                return store.dispatch(updateProjectLastModifiedLocally(projectUid, timestamp.toMillis()));
                                            case 7:
                                            case "end":
                                                return _context.stop();
                                        }
                                }, _callee);
                            }));
                            return function (_x2) {
                                return _ref2.apply(this, arguments);
                            };
                        }(), function (error) {
                            return console.error(error);
                        });
                        return _context2.abrupt("return", unsubscribe);
                    case 2:
                    case "end":
                        return _context2.stop();
                }
        }, _callee2);
    }));
    return function subscribeToProjectLastModified(_x) {
        return _ref.apply(this, arguments);
    };
}();
